/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { Avatar, Breadcrumb, Dropdown, Layout, Menu, MenuProps, theme } from 'antd';
import { LoginOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { AuthState, clearAccessToken, setAccessToken, setIsLogin } from '../../store/reducer/auth';
import { NavigationRoutes } from '../../navigation/type';
import { UserApi } from '../../apis';
import useSWR from 'swr';
import {
  BrowserRouter as Router,
  Route,
  Navigate,
  Link,
  useNavigate,
  useLocation,
} from 'react-router-dom';
import { Routes } from '../routes/routes';
import { LoginScreen } from '../../screens/auth/login';
import {
  BanIcon,
  CarFrontIcon,
  CarIcon,
  CircleDashedIcon,
  ClipboardListIcon,
  CombineIcon,
  FileBox,
  FolderIcon,
  LayoutListIcon,
  ListIcon,
  ListOrderedIcon,
  LockKeyholeIcon,
  MapIcon,
  OptionIcon,
  SettingsIcon,
  TableProperties,
  TablePropertiesIcon,
  UsersIcon,
} from 'lucide-react';
import './root-layout.css';
import { PermissionCode } from '../../hook/use-role';

const { Header, Content, Sider } = Layout;

type Props = {
  children: React.ReactNode;
};

const RootLayout = memo(({ children }: Props) => {
  const dispatch = useDispatch();
  const { accessToken, isLogin } = useSelector((state: { auth: AuthState }) => state?.auth);
  const { data, isLoading, error, mutate } = useSWR(accessToken ? '/api/user/me' : '', UserApi.me);

  const navigate = useNavigate();
  const location = useLocation();

  // const permissions = init?.permissions || [];

  const items: MenuProps['items'] = [
    {
      label: <span className="text-red-500">Гарах</span>,
      key: '3',
      icon: <LoginOutlined className="text-red-500" />,
      onClick: async (e) => {
        dispatch(clearAccessToken());
        mutate(undefined);
      },
    },
  ];

  React.useEffect(() => {
    const reload = async () => {
      if (error && (error || {})?.statusCode === 401 && !isLoading && isLogin) {
        try {
          const res = await UserApi.me();
          mutate(res, false);
        } catch (error: any) {
          dispatch(setIsLogin(false));
          dispatch(clearAccessToken());
        }
      }
    };

    reload();
  }, [accessToken, dispatch, error, isLoading, isLogin, mutate]);

  const [current, setCurrent] = useState('mail');

  const onClick: MenuProps['onClick'] = (e) => {
    console.log('click ', e);
    setCurrent(e.key);
    navigate(e.key);
  };
  // Суудлын автомашины үнэлгээ
  const menuConfig = useMemo(
    () => [
      {
        code: 'VALUATION',
        key: 'VALUATION',
        icon: <ListIcon width={17} height={17} strokeWidth={1.2} style={{ color: 'black' }} />,
        label: 'Автомашины үнэлгээ',
        path: '',
        children: [
          {
            key: NavigationRoutes.Home_Screen,
            icon: (
              <CarFrontIcon width={17} height={17} strokeWidth={1.2} style={{ color: 'black' }} />
            ),
            label: 'Суудлын автомашины',
            path: NavigationRoutes.Home_Screen,
            type: PermissionCode.IS_WRITE,
          },
          {
            key: NavigationRoutes.Valuation_ListScreen,
            type: PermissionCode.IS_VIEW,
            icon: (
              <ClipboardListIcon
                width={17}
                height={17}
                strokeWidth={1.2}
                style={{ color: 'black' }}
              />
            ),
            label: 'Үнэлгээний жагсаалт',
            path: NavigationRoutes.Valuation_ListScreen,
          },
        ],
      },
      {
        code: 'BRANCH',
        key: NavigationRoutes.Branch_Screen,
        icon: <MapIcon width={17} height={17} strokeWidth={1.2} style={{ color: 'black' }} />,
        label: 'Салбар',
        path: NavigationRoutes.Branch_Screen,
      },
      {
        code: 'USER',
        key: NavigationRoutes.User_ListScreen,
        icon: <UsersIcon width={17} height={17} strokeWidth={1.2} style={{ color: 'black' }} />,
        label: 'Хэрэглэгч удирдах',
        path: NavigationRoutes.User_ListScreen,
      },
      {
        code: 'CAR_BRAND',
        key: NavigationRoutes.Brand_ListScreen,
        icon: <FolderIcon width={17} height={17} strokeWidth={1.2} style={{ color: 'black' }} />,
        label: 'Брэнд удирдлага',
        path: NavigationRoutes.Brand_ListScreen,
      },
      {
        code: 'CAR_MODEL',
        key: NavigationRoutes.Model_ListScreen,
        icon: <FileBox width={17} height={17} strokeWidth={1.2} style={{ color: 'black' }} />,
        label: 'Загвар удирдлага',
        path: NavigationRoutes.Model_ListScreen,
      },
      {
        code: 'OPTION',
        key: NavigationRoutes.Option_ListScreen,
        icon: <OptionIcon width={17} height={17} strokeWidth={1.2} style={{ color: 'black' }} />,
        label: 'Нэмэлт тоноглол',
        path: NavigationRoutes.Option_ListScreen,
      },
      // {
      //   code: null, // permission шалгахгүй
      //   key: NavigationRoutes.User_Password_ChangeScreen,
      //   icon: (
      //     <LockKeyholeIcon width={17} height={17} strokeWidth={1.2} style={{ color: 'black' }} />
      //   ),
      //   label: 'Нууц үг солих',
      //   path: NavigationRoutes.User_Password_ChangeScreen,
      // },
      {
        code: 'ROLE',
        key: NavigationRoutes.Permission_listScreen,
        icon: <CombineIcon width={17} height={17} strokeWidth={1.2} style={{ color: 'black' }} />,
        label: 'Хандах эрх',
        path: NavigationRoutes.Permission_listScreen,
      },

      {
        code: 'SETTINGS_NON_COLLATERAL_VEHICLE',
        key: NavigationRoutes.Settings_NoneCollateralVehicle_Screen,
        icon: <BanIcon width={17} height={17} strokeWidth={1.2} style={{ color: 'black' }} />,
        label: 'Барьцаалахгүй машин',
        path: NavigationRoutes.Permission_listScreen,
      },

      // {
      //   code: 'SETTINGS',
      //   key: NavigationRoutes.Settings_Screen,
      //   icon: <SettingsIcon width={17} height={17} strokeWidth={1.2} style={{ color: 'black' }} />,
      //   label: 'Тохиргоо',
      //   path: NavigationRoutes.Settings_Screen,
      //   children: [
      //     {
      //       key: NavigationRoutes.Settings_NonCollateralVehicle_Screen,
      //       icon: <BanIcon width={17} height={17} strokeWidth={1.2} style={{ color: 'black' }} />,
      //       label: 'Барьцаалахгүй машин',
      //       path: NavigationRoutes.Settings_NonCollateralVehicle_Screen,
      //       type: PermissionCode.IS_WRITE,
      //     },
      //   ],
      // },
    ],
    []
  );

  // const ACTIVE_COLOR = '#005eff';

  const ACTIVE_COLOR = '#005eff';
  const DEFAULT_COLOR = '#00151D';

  const renderMenuItem = (item: any, isActive: any) => {
    const color = isActive ? ACTIVE_COLOR : DEFAULT_COLOR;

    return (
      <Menu.Item key={item.key} icon={React.cloneElement(item.icon, { color, stroke: color })}>
        <span style={{ color }}>{item.label}</span>
      </Menu.Item>
    );
  };

  const renderSubMenu = useCallback(
    (item: any, isActive: any) => {
      const color = isActive ? ACTIVE_COLOR : DEFAULT_COLOR;

      const has = data?.permissions[item.code] ?? {};

      return (
        <Menu.SubMenu
          key={item.key}
          title={<span style={{ color }}>{item.label}</span>}
          icon={React.cloneElement(item.icon, { color, stroke: color })}
        >
          {item.children.map((child: any) => {
            const childActive = location.pathname === child.key;
            if (child.type === PermissionCode.IS_VIEW && has.isView === true) {
              return renderMenuItem(child, childActive);
            }
            if (child.type === PermissionCode.IS_WRITE && has.isCreate === true) {
              return renderMenuItem(child, childActive);
            }
            return null;
          })}
        </Menu.SubMenu>
      );
    },
    [data?.permissions, location?.pathname]
  );

  const selectedKey = useMemo(() => {
    const allKeys = menuConfig.flatMap((m) => [m.key, ...(m.children?.map((c) => c.key) || [])]);

    const match = allKeys
      .filter((k) => location.pathname === k || location.pathname.startsWith(k))
      .sort((a, b) => b.length - a.length)[0];

    return match ?? '';
  }, [location.pathname, menuConfig]);

  const renderItems = useMemo(() => {
    return (
      <>
        {menuConfig.map((item) => {
          const isActive =
            selectedKey === item.key || (item.children || []).some((c) => c.key === selectedKey);

          if (item.code === 'SETTINGS') {
            return renderMenuItem(item, isActive);
          }

          if (item.code && !(data?.permissions || {})?.[item.code]?.hasAccess) {
            return null;
          }

          if (item.children) {
            return renderSubMenu(item, isActive);
          }

          if (item.code === 'SETTINGS') {
            return renderMenuItem(item, isActive);
          }

          return renderMenuItem(item, isActive);
        })}
      </>
    );
  }, [menuConfig, data?.permissions, selectedKey, renderSubMenu]);

  // if (!isLogin) {
  //   return (
  //     <Router>
  //       <Routes>
  //         <Route path="*" element={<Navigate to="/login" replace />} />
  //         <Route path={NavigationRoutes.Login_Screen} element={<LoginScreen />} />
  //       </Routes>
  //     </Router>
  //   );
  // }

  // if (!data) {
  //   return <></>;
  // }

  return (
    <Container>
      <Layout>
        <Header className="header">
          <div className="w-full flex flex-row justify-between">
            <div className="w-[100] h-[43] pl-[20px] mt-2">
              <img src={require('../../assets/main-logo.png')} className="w-[100px]" />
            </div>
            <div>
              <Dropdown menu={{ items }} trigger={['click']}>
                <div className="cursor-default">
                  <span className="text-black pr-2 text-w font-semibold text-[12px]">
                    {data && data?.lastName && data?.firstName
                      ? `${data.lastName} ${data.firstName}`
                      : ''}
                  </span>
                  <Avatar
                    src={'/logo.png'}
                    style={{ backgroundColor: '#ffffff', color: '#ffffff' }}
                  >
                    U
                  </Avatar>
                </div>
              </Dropdown>
            </div>
          </div>
        </Header>

        <Layout>
          <Sider width={290} className="side">
            <Menu
              mode="inline"
              selectedKeys={[selectedKey]}
              theme="light"
              style={{ border: 'none' }}
              className="custom-menu"
              onClick={onClick}
            >
              {renderItems}
            </Menu>
          </Sider>
          <Layout style={{ padding: '0 24px 24px' }}>
            <div className="pt-6"></div>
            <Content className="content">
              <Routes>{children}</Routes>
            </Content>
          </Layout>
        </Layout>
      </Layout>
    </Container>
  );
});

const Container = styled.div`
  .header {
    display: flex;
    align-items: center;
    background-color: white;
  }
  .side {
    background: white;
  }
  .demo-logo {
    width: 150px;
    height: 45px;
    background-color: #1a3b53;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .logo {
    width: 120px;
    display: none;
  }
  .content {
    margin: 0;
    min-height: '88vh';
    background: '#f3f3f3';
    border-radius: 8;
  }
`;

RootLayout.displayName = 'RootLayout';

export { RootLayout };
